export const apiURL = "https://project-manager-server.glitch.me";
export const image = (name) =>
  `https://avatars.dicebear.com/api/male/${name}.svg?mood[]=happy`;


